var map = {
	"./ADPC.jpeg": 9800,
	"./GRD.png": 530,
	"./PGFI-OG.png": 2012,
	"./Screenshot 2026-02-16 at 9.32.05ΓÇ»PM.png": 8082,
	"./Screenshot_10-3-2025_155342_.jpeg": 7042,
	"./WBF.jpeg": 9421,
	"./WBF.png": 7664,
	"./arihant.png": 2546,
	"./ashika.png": 2850,
	"./bahubali.png": 1483,
	"./bbbc.png": 7522,
	"./ca.jpeg": 6044,
	"./findoc.png": 6796,
	"./gay.png": 2406,
	"./gepl.jpeg": 40,
	"./greenview.png": 3761,
	"./gtpl.png": 8942,
	"./hns.jpeg": 1563,
	"./how.png": 3897,
	"./ic.png": 4475,
	"./inspira.png": 8333,
	"./kips.jpeg": 749,
	"./legendinnovators_logo.jpeg": 2796,
	"./mg.jpg": 5835,
	"./mgl.jpeg": 144,
	"./mores.jpeg": 4062,
	"./nalanda.jpeg": 3395,
	"./odb.png": 4474,
	"./profit.jpeg": 6098,
	"./railbit_engineers_private_limited_logo.jpeg": 3479,
	"./ruban.png": 6221,
	"./utopian.fit_Logo.jpg": 1010,
	"./vhipl.png": 8992,
	"./wbfo.jpeg": 2458,
	"./zeebangla.jpeg": 6953
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8831;